import Colors from "Constants/Color";
import { Modal, Table } from "react-bootstrap";

interface Bag {
    inventory_item_id?: string | number;
    bag_no: string;
    available_quantity: number;
    issue_quantity: number;
}

interface QuotationViewBagsModalProps {
    show: boolean;
    handleClose: () => void;
    bags: Bag[];
}

const QuotationViewBagsModal: React.FC<QuotationViewBagsModalProps> = ({
    show,
    handleClose,
    bags = []
}) => {
    // Calculate total issue quantity
    const totalIssueQuantity = bags.reduce((sum, bag) => {
        return sum + (parseFloat(String(bag.issue_quantity)) || 0);
    }, 0);

    // Calculate total available quantity
    const totalAvailableQuantity = bags.reduce((sum, bag) => {
        return sum + (parseFloat(String(bag.available_quantity)) || 0);
    }, 0);

    return (
        <Modal show={show} onHide={handleClose} centered size="lg">
            <Modal.Header className="border-0">
                <Modal.Title className="fw-bold">Bag Details</Modal.Title>
                <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={handleClose}
                />
            </Modal.Header>
            <hr />
            <Modal.Body>
                {bags.length === 0 ? (
                    <div className="text-center py-4 text-muted">
                        No bags added.
                    </div>
                ) : (
                    <>
                    <Table responsive className="align-middle">
                        <thead className="table-light border-bottom">
                            <tr>
                                    <th style={{ minWidth: 70 }} className="py-3 px-3 text-center">
                                    Sr No.
                                </th>
                                <th style={{ minWidth: 200 }} className="py-3 px-3">
                                    Bag No.
                                </th>
                                    <th style={{ minWidth: 200 }} className="py-3 px-3 text-end">
                                    Available Quantity
                                </th>
                                    <th style={{ minWidth: 200 }} className="py-3 px-3 text-end">
                                    Issue Quantity
                                </th>
                                    <th style={{ minWidth: 200 }} className="py-3 px-3 text-end">
                                        Remaining Quantity
                                    </th>
                            </tr>
                        </thead>
                        <tbody>
                                {bags.map((bag, idx) => {
                                    const availableQty = parseFloat(String(bag.available_quantity)) || 0;
                                    const issueQty = parseFloat(String(bag.issue_quantity)) || 0;
                                    const remainingQty = availableQty - issueQty;
                                    
                                    return (
                                <tr key={idx} className="border-bottom">
                                            <td className="py-2 px-3 text-center">{idx + 1}</td>
                                            <td className="py-2 px-3">
                                                <strong>{bag.bag_no || "-"}</strong>
                                            </td>
                                            <td className="py-2 px-3 text-end">
                                                {availableQty.toFixed(2)}
                                            </td>
                                            <td className="py-2 px-3 text-end">
                                                <strong style={{ color: Colors?.bg_blue }}>
                                                    {issueQty.toFixed(2)}
                                                </strong>
                                            </td>
                                            <td className="py-2 px-3 text-end">
                                                <span style={{ 
                                                    color: remainingQty >= 0 ? "#28a745" : "#dc3545",
                                                    fontWeight: remainingQty >= 0 ? "normal" : "bold"
                                                }}>
                                                    {remainingQty.toFixed(2)}
                                                </span>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                            <tfoot className="table-light border-top">
                                <tr>
                                    <td colSpan={2} className="py-2 px-3">
                                        <strong>Total</strong>
                                    </td>
                                    <td className="py-2 px-3 text-end">
                                        <strong>{totalAvailableQuantity.toFixed(2)}</strong>
                                    </td>
                                    <td className="py-2 px-3 text-end">
                                        <strong style={{ color: Colors?.bg_blue }}>
                                            {totalIssueQuantity.toFixed(2)}
                                        </strong>
                                    </td>
                                    <td className="py-2 px-3 text-end">
                                        <strong style={{ 
                                            color: (totalAvailableQuantity - totalIssueQuantity) >= 0 ? "#28a745" : "#dc3545"
                                        }}>
                                            {(totalAvailableQuantity - totalIssueQuantity).toFixed(2)}
                                        </strong>
                                    </td>
                                </tr>
                            </tfoot>
                    </Table>
                        <div className="mt-3 p-3" style={{ backgroundColor: "#f8f9fa", borderRadius: "4px" }}>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <span style={{ fontSize: "0.875rem", color: "#212529" }}>
                                    Total Available Quantity:
                                </span>
                                <span style={{ fontSize: "0.875rem", fontWeight: "500", color: "#212529" }}>
                                    {totalAvailableQuantity.toFixed(2)}
                                </span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <span style={{ fontSize: "0.875rem", color: "#212529" }}>
                                    Total Issue Quantity:
                                </span>
                                <span style={{ fontSize: "0.875rem", fontWeight: "500", color: Colors?.bg_blue }}>
                                    {totalIssueQuantity.toFixed(2)}
                                </span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                                <span style={{ fontSize: "0.875rem", color: "#212529" }}>
                                    Total Remaining Quantity:
                                </span>
                                <span style={{ 
                                    fontSize: "0.875rem", 
                                    fontWeight: "500", 
                                    color: (totalAvailableQuantity - totalIssueQuantity) >= 0 ? "#28a745" : "#dc3545"
                                }}>
                                    {(totalAvailableQuantity - totalIssueQuantity).toFixed(2)}
                                </span>
                            </div>
                        </div>
                    </>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default QuotationViewBagsModal;

